import { getChildOrgIdsFromToken } from 'src/utils/jwtTokenUtils'

export const CUSTOM_DASHBOARDS_PERMISSION = 'dashboards:custom_dashboards:read'
export const AZURE_INSIGHTS_DASHBOARDS_PERMISSION =
    'dashboards:public-cloud:read'
export const CUSTOM_DASHBOARDS_EDITOR_PERMISSION = 'dashboards:luzmo:editor'
export const CUSTOM_DASHBOARDS_VIEW_MENU = 'dashboards:dashboards_menu:view'
export const SSR_DASHBOARDS_READ_PERMISSION = 'dashboards:ssr:read'
export const HEALTH_PERMISSION = 'reporting:table:health_management'
export const RUNBOOK_PERMISSION = 'runbooks:webui:login'
export const INVENTORY_DEVICES_PERMISSION = 'reporting:table:ci'
export const INVENTORY_DEVICES_READ = 'reporting:inventory-devices:read'
export const INVENTORY_CAPACITY_PERMISSION = 'reporting:table:inventory'
export const INVENTORY_SAM_PERMISSION = 'reporting:table:t_SAM'
export const INCIDENT_REPORTING_PERMISSION = 'reporting:table:incident'

export const GLOBAL_SEARCH_PERMISSION = 'search:global:use'
export const HR_PROFILE_PERMISSION = 'hr_portal:hr_profile:use'
export const EMPLOYEE_PROFILE_PERMISSION = 'hr_portal:employee_profile:use'
export const MANAGER_PROFILE_PERMISSION = 'hr_portal:employee_manager:use'
export const TIMESHEETS_PERMISSION = 'hr_portal:timesheets:use'
export const ABSENCES_PERMISSION = 'hr_portal:absences:use'
export const TIMESHEETS_LOCATION_PERMISSION = 'hr_portal:work_location:use'
export const COST_CONTROL_PERMISSION = 'reporting:table:t_Cost_Control'
export const ORDER_CATALOG_PERMISSION = 'catalog:productcatalog:read'
export const COLLABORATION_PERMISSION = 'itsm:ticket:read'
export const COLLABORATION_RFC_PERMISSION = 'itsm:rfc:read'
export const ITSM_SEARCH_TICKETS_READ = 'itsm:search:read-tickets'
export const AZURE_INSIGHTS_USE = 'dashboards:azure_insights:use'
export const GOVERNANCE_ROLES_PERMISSION = 'reporting:table:escalation_matrix'
export const ASSOCIATED_CI_READ_PERMISSION = 'reporting:associated_ci:read'
export const SERVICE_DESK_INFO_PERMISSION = 'reporting:table:service_desk_info'
export const KUBEPORT_PERMISSION = 'reporting:kubeport:read'
export const ORDERS_ORDER_CREATE_READ = 'orders:order:create-and-read'
export const DOCUMENTS_READ = 'documents:document:read'
export const DOCUMENTS_READ_ALL = 'documents:document:read-all'
export const DOCUMENTS_UPDATE = 'documents:document:update'
export const DOCUMENTS_CREATE = 'documents:document:create'

const DOCUMENT_CATEGORY_KEYS = [
    'invoices',
    'general',
    'reports',
    'security',
    'presentations',
    'management',
    'knowledge',
]

export const DOCUMENTS_CATEGORIES_CREATE_UPDATE = DOCUMENT_CATEGORY_KEYS.map(
    key => `documents:dpc.${key}:create-update`
)

export const DOCUMENTS_CATEGORIES_READ = DOCUMENT_CATEGORY_KEYS.map(
    key => `documents:dpc.${key}:read`
)
export const SERVICE_PORTFOLIO_OVERVIEW = 'orders:order:view-overview'
export const CORE_CMDB_VIEW = 'core:cmdb:view'
export const EVENTS_READ_ALL = 'events:event:read-all'
export const EVENTS_READ_OWN = 'events:event:read-own'
export const MON_PERMISSIONS = [
    CORE_CMDB_VIEW,
    EVENTS_READ_ALL,
    EVENTS_READ_OWN,
]
export const WORKFLOWS_WEBUI_LOGIN = 'workflows:webui:login'
export const DWP_PERMISSION = 'dashboards:dwp:read'
//TODO: when we refactor the rendering of the menu to the mfe, we need to remove these permissions
export const ITSM_SUPPORT_CENTER_CONTACT_PERMISSION =
    'itsm:support-center-contact:search'
// TODO remove this from root
export const ITP_INTEGRATION_OVERVIEW_PERMISSION =
    'itsm_trigger_processor:itsm-integration-overview:read'
export const ITP_MANAGER_OVERVIEW_PERMISSION =
    'itsm_trigger_processor:itsm-integration-manager:read'

export const SUPPORT_WORKSPACE_USE_PERMISSION = 'itsm:support-workspace:use'

export const DASHBOARDS_HOMEPAGE_V2 = 'dashboards:homepage_v2:use'
export const CSOD_REGISTER_PERMISSION = 'security:csaf:register'
export const SECURITY_ACTION_EXCEPTION_USE = 'security:action-exception:use'
export const SECURITY_CSAF_MODULE_DETAIL_USE = 'security:csaf-module-detail:use'
export const SECURITY_ADMIN_VM_RECLASSIFICATION =
    'security:vm-reclassification:admin'
export const SECURITY_BASELINE_DSB = 'security:baseline-mngt-dsb:use'
export const SECURITY_BASELINE_CSB = 'security:baseline-mngt-csb:use'
export const CSOD_VIEW_PERMISSION = 'security:csaf:use'
export const CSOD_ADMIN_PERMISSION = 'security:csaf:admin'
export const CSOD_SECURITY_MIGRATED_PAGES_USE = 'security:migrated-pages:use'
export const SECURITY_CUSTOMER_SCOPING_USE = 'security:customer-scoping:use'
export const SECURITY_CCF_CUSTOMER_USE = 'security:ccf-customer:use'
export const INCIDENT_MANAGER_VIEW_PERMISSIONS =
    'ctc:channel:manage-p1-messages'

export const ERP_VIEW_PERMISSION = 'erp_portal:erp:use'
export const ERP_PROCUREMENT_USE = 'erp_portal:procurement:use'
export const ERP_EXPENSES_PERMISSION = 'erp_portal:expenses:use'
export const ERP_ABSENCES_PERMISSION = 'erp_portal:absences:use'

export const SECURITY_VULNERABILITY_USE = 'security:vulnerability:use'
export const SECURITY_VM_URGENT_VULNERABILITY =
    'security:vm-urgent-vulnerability:use'
export const SECURITY_VM_LIVE_AGENTS_USE = 'security:vm-live-agents:use'
export const SECURITY_VM_PATCH_INFO_USE = 'security:vm-patch-info:use'
export const SECURITY_COMPLIANCE_USE = 'security:compliance:use'
export const SECURITY_MPAM_DASHBOARD_USE = 'security:mpam-dashboard:use'
export const SECURITY_DETECT_RESPONSE_USE = 'security:detectresponse:use'
export const SECURITY_COVERAGE_SCOPE_USE = 'security:coverage-scope:use'
export const SECURITY_COVERAGE_THREAT_USE = 'security:coverage-threat:use'
export const SECURITY_COVERAGE_USECASE_USE = 'security:coverage-usecase:use'
export const SECURITY_VM_EOL_USE = 'security:vm-eol:use'
export const ADMIN_VIEW_PERMISSIONS = 'adminui:ui:login'
export const SECURITY_MENU_PERMISSIONS = [
    SECURITY_VULNERABILITY_USE,
    SECURITY_COMPLIANCE_USE,
    SECURITY_DETECT_RESPONSE_USE,
    SECURITY_MPAM_DASHBOARD_USE,
]
export const CSAF_MENU_PERMISSIONS = [
    CSOD_REGISTER_PERMISSION,
    CSOD_VIEW_PERMISSION,
    CSOD_ADMIN_PERMISSION,
    CSOD_SECURITY_MIGRATED_PAGES_USE,
]
export const SECURITY_COVERAGE_PERMISSIONS = [
    SECURITY_COVERAGE_SCOPE_USE,
    SECURITY_COVERAGE_THREAT_USE,
    SECURITY_COVERAGE_USECASE_USE,
]

export const CEGEKA_ORGANIZATION_ID = '656'

export function isAllowed(context, permission) {
    if (!context?.permissions) {
        return false
    }

    const { permissions } = context
    const invert = permission.startsWith('!')
    if (invert) {
        return !permissions.includes(permission.substring(1))
    }
    return permissions.includes(permission)
}

export function isGlobalAdmin(context) {
    return context?.data?.is_global_admin
}

export function isAnyAllowed(context, permissions) {
    return permissions.some(permission => isAllowed(context, permission))
}

export function isAllAllowed(context, permissions) {
    return permissions.every(permission => isAllowed(context, permission))
}

export function getCurrentOrganizationId(context) {
    if (context?.impersonatedOrganization) {
        return (
            context.impersonatedOrganization.organization_id ??
            context.impersonatedOrganization.value
        )
    }
    return context?.data?.organization_id
}

export function getGlobalSubsidiary(userData, subsidiaryData) {
    return subsidiaryData.currentGlobalSubsidiary
        ? [subsidiaryData.currentGlobalSubsidiary.id]
        : [getCurrentOrganizationId(userData)]
}

export function isCegekaEmployee(context) {
    return getCurrentOrganizationId(context) === CEGEKA_ORGANIZATION_ID
}

export function hasSubtenants(context) {
    return getChildOrgIdsFromToken(context.authToken)?.length > 0
}

export function getSubtenants(context) {
    return getChildOrgIdsFromToken(context.authToken)
}

export function hasDebugMenu(context) {
    return (
        window?.localStorage?.getItem('__horizon_debug__') &&
        isGlobalAdmin(context) &&
        isCegekaEmployee(context)
    )
}

export function getCompanyID(context) {
    return context?.data?.company_id
}
